import { AppServiceConfig } from './apiGatewayFactory';

export const enum Env {
    LOCAL = 'LOCAL',
    ALPHA = 'ALPHA',
    BETA = 'BETA',
    GAMMA = 'GAMMA',
    PROD = 'PROD',
}

export const AI_PLAYGROUND_CONFIGS: AppServiceConfig = {
    // for local environment, you would need to run an additional reverse proxy server at localhost:3001
    // browser -> reverse proxy -> API Gateway
    [Env.LOCAL]: { endpoint: 'http://localhost:3001', region: 'us-east-1' },
    [Env.BETA]: { endpoint: 'https://beta.app.ai.ring.amazon.dev', region: 'us-east-1' },
    [Env.GAMMA]: { endpoint: 'https://gamma.app.ai.ring.amazon.dev', region: 'us-east-1' },
    [Env.PROD]: { endpoint: 'https://app.ai.ring.amazon.dev', region: 'us-east-1' },
};